<template>
  <div id="team_type">
    <div class="con_all" v-if="$route.meta.keepAliveSub3">
      <div class="con_box2">
        <div class="psear mb10" v-html="showIntroduction()">
        </div>
        <div class="photo_box" v-for="(album,index) in albums" :key="index">
          <router-link :to="{ name: 'photo_in', params: { albumId: album.id } }">
            <div class="photo_box_icon">
              {{showMemo(album)}}
              <div class="mt10">
                <button type="submit" class="photo_btn">more</button>
              </div>
            </div>
            <div class="photo_box_pic"><img :src="album.coverPictureUrl"></div>
            <!--<div class="photo_box_pic"><img src="/../static/images/1.jpg"></div>-->
            <div class="photo_box_title">{{showName(album)}}</div>
            <div class="photo_box_tx">{{showPage.totalCount}}{{album.pictureCount}}{{showPage.item}}</div>
          </router-link>
        </div>
        <div class="fix"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';


export default {
  name: 'team_type',
  props: ['teams'],
  data() {
    return {
      teamId: this.$route.params.teamid,
      team: '',
      albums: [],
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  watch: {
    teams() {
      this.init();
    }
  },
  methods: {
    init() {
      this.initTeam();
      this.initAlbums();
    },
    initTeam() {
      this.teams.some(team => {
        if (team.id == this.teamId) {
          this.team = team;
          return true;
        }
      });
    },
    initAlbums() {
      this.getAlbumsData();
    },
    getAlbumsData() {
      axios.get(API.album + `?teamId=${this.teamId}`)
        .then(response => {
          this.albums = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    showName(album) {
      let show = {'CH': album.nameCh, 'EN': album.nameEn}
      return show[sessionStorage.locale];
    },
    showIntroduction() {
      let introduction = {CH: (this.team.introductionCh), 
                          EN: (this.team.introductionEn)};
      return introduction[sessionStorage.locale];
    },
    showMemo(album) {
      let show = { 'CH': album.memoCh, 'EN': album.memoEn }
      return show[sessionStorage.locale];
    }
  },
}

</script>
<style lang="scss">
#team_type {
  padding: 0 !important;
  .photo_box_pic {
    height: 200px;
    overflow: hidden;
  }
  .photo_box_title {
    height: 30px;
  }
}

a {
  color: white;
}

</style>



// WEBPACK FOOTER //
// TeamInfo.vue?6e8711ed